import { mapRange } from "../util/math";

export default function TwoColorText(props) {
  const minScale = props.minScale || 10;
  const maxScale = props.maxScale || 7;
  const maxScaleSmall = props.maxScaleSmall || 1;
  const minScaleSmall = props.minScaleSmall || 10;

  const scale = mapRange(props.text.length, 1, 20, maxScale, minScale);

  let fontSize = `clamp(0px, (100vw - 4.5rem) / ${scale}, 400px)`;

  if (props.windowWidth <= 768) {
    const scale = mapRange(
      props.text.length,
      1,
      15,
      maxScaleSmall,
      minScaleSmall
    );
    fontSize = `clamp(0px, (100vw - 4.5rem) / ${scale}, 400px)`;
  }

  return (
    <div className={`relative ${props.classes}`}>
      {props.skipMultiply && (
        <h1
          className={`text-5xl pb-6 color-secondary absolute top-0 opacity-100`}
          style={{
            fontFamily: props.font.headerFontFamily,
            fontSize,
          }}
        >
          {props.text}
        </h1>
      )}
      <h1
        className={`text-5xl pb-6 absolute color-${props.color} mix-blend-hard-light opacity-50 t1`}
        style={{
          background: 'url("/img/bg-noise.png") 0 0 / cover repeat',
          backgroundClip: "text",
          WebkitTextFillColor: "transparent",
          fontFamily: props.font.headerFontFamily,
          fontSize,
        }}
      >
        {props.text}
      </h1>
      <h1
        className={`text-5xl pb-6 color-${props.bgColor} absolute top-0 mix-blend-multiply opacity-30`}
        style={{
          transform: "translate(2px, 1px) rotate(-0.5deg)",
          fontFamily: props.font.headerFontFamily,
          fontSize,
        }}
      >
        {props.text}
      </h1>
      <h1
        className={`text-5xl pb-6 color-${props.color} mix-blend-multiply opacity-100 t1`}
        style={{
          fontFamily: props.font.headerFontFamily,
          fontSize,
        }}
      >
        {props.text}
      </h1>
    </div>
  );
}
